export default __webpack_public_path__ + "static/media/GrowMore360_Logo.6098a966.svg";